export default __webpack_public_path__ + "static/media/Lateef.f2df1f78.woff";